import { ReactNode } from 'react';

export const REQUIRED_AGE = 18;

export enum ErrorCodes {
	DUPLICATED_USER = 1,
	UNEXPECTED_ERROR = 2,
}

export enum ErrorDescriptions {
	DUPLICATED_USER = 'Ya existe un usuario con el mismo email, número de documento o CUIT/CUIL.',
	UNEXPECTED = 'Ocurrió un error inesperado. Inténtalo nuevamente.',
}

export const CUIT_CUIL_MASK = '##-########-#';
export const CELLPHONE_MASK = '0000000000';

export enum UserStatus {
	CREATED = 'CREADO',
	VERIFIED = 'VERIFICADO',
	ACCEPTED = 'ACTIVO',
	REJECTED = 'RECHAZADO',
	SUSPENDED = 'SUSPENDIDO',
	EXPELLED = 'EXPULSADO',
}

export const contactInfo = {
	cellphone: '5493731651333',
	email: 'administrador@cambiapp.net',
};

export const VERIFIED_MODAL_CONTENT: {
	title: string;
	description: ReactNode;
} = {
	title: '¡Tu email fue verificado exitosamente! ✅',
	description: (
		<>
			<p>
				Sólo falta el último paso… <br />
				<br />
				El Administrador verificará tu solicitud y podría contactarse con vos
				para resolver tu admisión a la Comunidad CambiApp. <br />
				<br />
				Te comunicaremos vía correo electrónico cuando tu cuenta ya esté
				activada para comenzar a operar.
			</p>
		</>
	),
};

export const CREATED_MODAL_CONTENT: {
	title: string;
	description: ReactNode;
	showResend: boolean;
} = {
	title: '¡Tu cuenta fue creada exitosamente!',
	description: (
		<>
			Por favor, revisa la casilla de tu correo electrónico para verificar tu
			email.
		</>
	),
	showResend: true,
};

export const REJECTED_MODAL_CONTENT: {
	title: string;
	description: ReactNode;
} = {
	title: 'Solicitud rechazada',
	description: (
		<>
			<p>
				Tu solicitud se encuentra rechazada. <br />
				<br />
				Para mayor información podes comunicarte con el soporte de CambiApp.
				<br />
				<br />
				{`+${contactInfo.cellphone}`}
				<br />
				{contactInfo.email}
			</p>
		</>
	),
};

export const EXPELLED_MODAL_CONTENT: {
	title: string;
	description: ReactNode;
} = {
	title: 'Cuenta inhabilitada',
	description: (
		<>
			<p>
				Tu cuenta se encuentra inhabilitada. <br />
				<br />
				Para mayor información podes comunicarte con el soporte de CambiApp.
				<br />
				<br />
				{`+${contactInfo.cellphone}`}
				<br />
				{contactInfo.email}
			</p>
		</>
	),
};

export const SUSPENDED_MODAL_CONTENT: {
	title: string;
	description: ReactNode;
} = {
	title: 'Cuenta suspendida',
	description: (
		<>
			<p>
				Tu cuenta se encuentra suspendida. <br />
				<br />
				Para mayor información podes comunicarte con el soporte de CambiApp.
				<br />
				<br />
				{`+${contactInfo.cellphone}`}
				<br />
				{contactInfo.email}
			</p>
		</>
	),
};

export const RESET_PASSWORD_MODAL_CONTENT: {
	title: string;
	description: ReactNode;
} = {
	title: 'Restablecer contraseña',
	description: (
		<>
			<p>
				Ingresa tu email y te enviaremos un correo para actualizar tu
				contraseña. <br />
				<br />
			</p>
		</>
	),
};

export const ERROR_MODAL_CONTENT: {
	title: string;
	description: ReactNode;
} = {
	title: 'Error',
	description: (
		<>
			<p>
				Lo sentimos, ocurrió un error <br />
				<br />
				Para mayor información podes comunicarte con el soporte de CambiApp.
				<br />
				<br />
				{`+${contactInfo.cellphone}`}
				<br />
				{contactInfo.email}
			</p>
		</>
	),
};
